import axios from '@/utils/axios';
import queryString from '@/utils/queryString';
 export default {
    namespaced: true,
    state: {
        itemMeasureUnit: null,
        itemMeasureUnits: [],
    },
    mutations: {
        setItemMeasureUnit(state, payload) {
            state.itemMeasureUnit = payload;
        },
        setItemMeasureUnits(state, payload) {
            state.itemMeasureUnits = payload;
        },
        clearItemMeasureUnits(state) {
            state.itemMeasureUnits = []
        }
    },
    actions: {
        storeItemMeasureUnit({rootState, dispatch}, payload){
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        updateItemMeasureUnit({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        removeItemMeasureUnit({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        removeItemMeasureUnits({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        fetchItemMeasureUnit({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setItemMeasureUnit', response.data)
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        fetchItemMeasureUnits({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-measure-units?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setItemMeasureUnits', response.data)
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        clearItemMeasureUnits({commit}) {
            commit("clearItemMeasureUnits");
        }

    }
 }